// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/gender.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/gender.proto.
 */
export const file_general_gender: GenFile = /*@__PURE__*/
  fileDesc("ChRnZW5lcmFsL2dlbmRlci5wcm90bxIOcHJvdG9zLmdlbmVyYWwqxAEKBkdlbmRlchISCg5HRU5ERVJfVU5LTk9XThAAEhIKDkdFTkRFUl9BR0VOREVSEAESEQoNR0VOREVSX0ZFTUFMRRACEhYKEkdFTkRFUl9HRU5ERVJGTFVJRBADEg8KC0dFTkRFUl9NQUxFEAQSFQoRR0VOREVSX05PTl9CSU5BUlkQBRIVChFHRU5ERVJfVFdPX1NQSVJJVBAGEhAKDEdFTkRFUl9RVUVFUhAHEhYKEkdFTkRFUl9UUkFOU0dFTkRFUhAIYgZwcm90bzM");

/**
 * @generated from enum protos.general.Gender
 */
export enum Gender {
  /**
   * @generated from enum value: GENDER_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: GENDER_AGENDER = 1;
   */
  AGENDER = 1,

  /**
   * @generated from enum value: GENDER_FEMALE = 2;
   */
  FEMALE = 2,

  /**
   * @generated from enum value: GENDER_GENDERFLUID = 3;
   */
  GENDERFLUID = 3,

  /**
   * @generated from enum value: GENDER_MALE = 4;
   */
  MALE = 4,

  /**
   * @generated from enum value: GENDER_NON_BINARY = 5;
   */
  NON_BINARY = 5,

  /**
   * @generated from enum value: GENDER_TWO_SPIRIT = 6;
   */
  TWO_SPIRIT = 6,

  /**
   * @generated from enum value: GENDER_QUEER = 7;
   */
  QUEER = 7,

  /**
   * @generated from enum value: GENDER_TRANSGENDER = 8;
   */
  TRANSGENDER = 8,
}

/**
 * Describes the enum protos.general.Gender.
 */
export const GenderSchema: GenEnum<Gender> = /*@__PURE__*/
  enumDesc(file_general_gender, 0);

